import { useEffect, useRef, useState } from "react";
import { useGetResumeTemplatesData } from "../../ServiceHooks/resumeBuilderHooks";
import Tabs from "../../Components/CommonCommponents/Tabs/Tabs";
import { isEmpty } from "lodash";
import { Button, Skeleton } from "antd";
import { getSafeHtml } from "../../Utils/ResumeBuilder/Constant";
import { DownloadOutlined } from "@ant-design/icons";
import ResumeFormProfile from "./ResumeFormProfile";
import ResumeFormExperience from "./ResumeFormExperience";
import ResumeFormEducation from "./ResumeFormEducation";
import ResumeFormProjects from "./ResumeFormProject";
import ResumeBuilderService from "../../Service.js/ResumeBuilderService";
import RequiredFieldForm from "./RequiredFielddForm";
import toast from "react-hot-toast";

const ResumeForm = ({
  template,
  title,
  fields,
  candidate_id,
  template_id,
  userId,
  close,
}) => {
  const contentRef = useRef(null);
  const [enable, setEnable] = useState(true);
  const [resume_templates_data, setTemplateData] = useState();
  const [required_fields, setRequiredFields] = useState([]);
  const [templateFields, setTemplateFields] = useState([]);

  const { data, isLoading, error, isFetching } = useGetResumeTemplatesData({
    params: {
      candidate_id,
      template_id,
    },
    enabled: enable,
    cacheTime: 0,
  });
  useEffect(() => {
    console.log(error, "dataDATA", data);
    if (data) {
      setTemplateData(data);
      const temp_fields = Object.keys(data);
      setTemplateFields(temp_fields);
      setRequiredFields([]);
    } else if (error?.response?.data?.error_info) {
      setEnable(false);
      const req_fields = Object.keys(error?.response?.data?.error_info);
      setRequiredFields(req_fields);
    }
  }, [data, error]);
  const CANDIDATE_DETAILS_TAB_KEYS = {
    JOBS: "jobs",
    RESUME: "resume",
    PROFILE: "profile",
    DOCUMENTS: "documents",
    EXPERIENCE: "experience",
  };
  const downloadPdf = async (htmlCont) => {
    const formData = new FormData();
    formData.append("html", htmlCont);

    try {
      const response = await ResumeBuilderService.getExportResumePdf(formData);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "resume.pdf");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading PDF", error);
    }
  };
  const tabsArray = [
    {
      key: CANDIDATE_DETAILS_TAB_KEYS.PROFILE,
      tabName: "Profile",
      children: (
        <ResumeFormProfile
          setTemplateData={setTemplateData}
          resume_templates_data={data}
          templateFields={templateFields}
        />
      ),
      enable: true,
    },
    {
      key: CANDIDATE_DETAILS_TAB_KEYS.EXPERIENCE,
      tabName: "Experience",
      children: (
        <ResumeFormExperience
          experiences={resume_templates_data?.experiences?.value}
          setTemplateData={setTemplateData}
        />
      ),
      enable: templateFields.includes("experiences"),
    },
    {
      key: "projects",
      tabName: "Projects",
      children: (
        <ResumeFormProjects
          projects={resume_templates_data?.projects?.value}
          setTemplateData={setTemplateData}
        />
      ),
      enable: templateFields.includes("projects"),
    },
    {
      key: "educations",
      tabName: "Educations",
      children: (
        <ResumeFormEducation
          qualifications={resume_templates_data?.qualifications?.value}
          setTemplateData={setTemplateData}
        />
      ),
      enable: templateFields.includes("qualifications"),
    },
  ].filter((item) => !isEmpty(item) && item.enable === true);

  console.log(templateFields, "templateFields", required_fields);

  const tabsItems = tabsArray.map((item) => {
    return {
      key: item.key,
      label: item.tabName,
      children: item.children,
    };
  });
  console.log("required_fields", required_fields);

  useEffect(() => {
    if (required_fields.includes("maximum_chance")) {
      toast.error("Number of times to build resume exceeded");
      close(false);
    }
  }, [required_fields, close]);
  return (
    <>
      {required_fields?.length && (!isLoading || !isFetching) ? (
        <RequiredFieldForm
          fields={required_fields}
          candidate_id={candidate_id}
          setEnable={setEnable}
          userId={userId}
          setRequiredFields={setRequiredFields}
        />
      ) : (
        <div className="flex w-full">
          <div className="lg:w-[50%] w-full">
            <p className="mb-2">{title}</p>
            {isLoading || isFetching ? (
              <Skeleton
                active
                paragraph={{ rows: 20, width: "100%" }}
                shape="square"
                className="w-full rounded-md h-full p-4"
              />
            ) : (
              <>
                <div
                  ref={contentRef}
                  className="w-full bg-[#fff] cursor-pointer border border-gray-200 max-h-[90vh] h-[90vh] overflow-y-auto customScrollBar"
                  dangerouslySetInnerHTML={{
                    __html: getSafeHtml(template, resume_templates_data),
                  }}
                />
                <div className="w-full flex items-center justify-end">
                  <Button
                    onClick={() =>
                      downloadPdf(getSafeHtml(template, resume_templates_data))
                    }
                    className="mt-2"
                    type="primary"
                    icon={<DownloadOutlined />}
                    size={"medium"}
                  >
                    Download
                  </Button>
                </div>
              </>
            )}
          </div>
          <div className="p-10 lg:w-[48%] w-full">
            <Tabs
              items={tabsItems}
              // activeKey={infoTabName}
              defaultActiveKey={CANDIDATE_DETAILS_TAB_KEYS.PROFILE}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default ResumeForm;
